import React, { createRef } from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import axios from 'axios'
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST } from './../_getjson';
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import { parseJwt } from "../parseJWT";
require('../_css/PopUpOther.css');
export default class PopUpwarehouseAll extends React.Component {
    constructor(props) {
        super(props)
        this.Code = createRef();
        this.state = {
            type: this.props.type,
            col: [],
            rows: [],
            valueRetuen: "",
            Htext: "",
            SHtype: 3,
            showSH: '',
            textSearch: "",
            autoClose: 3600,
            selected: "0",
            messagealert: "",
            openBackdrop: false
        }
    }
    componentDidMount() {
        this._loadData("");

    }
    _loadData = async (Search) => {

        let Tokenstr = parseJwt(localStorage.getItem("Token"));
        console.log("Tokenstr", Tokenstr.User.CODE);
        await this.setState({ siteCodeUser: Tokenstr.User.CODE });

        this.setState({ openBackdrop: true })
        this.setState({ Htext: "ที่เก็บ" });
        var SearchCode = ""
        if (Search === "Y") {
            console.log();
            if (this.state.selected === "0") {
                SearchCode = await "&txtsearch=" + this.Code.current.value
            }
            if (this.state.selected === "1") {
                SearchCode = await "&txtsearch=" + this.Code.current.value
            }
        } else {
            this.Code.current.value = ""
        }
        var arrdata = [];
        var url = "CSSTKWAREHOUSE/Warehousedefault?usercode=" + this.state.siteCodeUser + SearchCode
        console.log(genURL(url));
        await axios.get(genURL(url)).then(res => {
            if (res.data.length > 0) {
                arrdata = res.data
            } else {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่พบข้อมูล" })
                this.setState({ openBackdrop: false })
            }
        }).then(_ => {
            this.setState({ rows: arrdata });
            this.setState({ openBackdrop: false })
        }).catch(error => {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
            this.setState({ openBackdrop: false })
        });
    }
    onSelectRow = (data) => {
        this.props.GetPopUpwarehouseAll(data);
    }
    _keyDown = (event) => {
        if (event.key === 'Enter') {
            this._loadData("Y");
        }
    }
    render() {
        const indexN = (cell, row, enumObject, index) => {
            return (<div>{index + 1}</div>)
        }
        return (
            <div className='popup' onKeyDown={this._keyDown}>
                <Backdrop open={this.state.openBackdrop} />
                <div className='popup_inner'>
                    {this.props.Data}
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-search" > {this.state.Htext} </i></div>
                        <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>
                    <div className="panel-body divTable" align="left">
                        <div className="form-inline">
                            <div className="form-group mb-2">
                                <input type='radio' id='Choice-1' name='myRadio' value='0' checked={this.state.selected === "0"} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากรหัสสาขา&nbsp;&nbsp;&nbsp;</span>
                                <input type='radio' id='Choice-2' name='myRadio' value='1'
                                    checked={this.state.selected === "1"} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากรหัสที่เก็บ&nbsp;</span>
                            </div>
                        </div>
                        <div className="input-group width-grop" >
                            <input type="text" className="form-control" placeholder="กรอกรหัสสาขาหรือรหัสที่เก็บ" ref={this.Code} onKeyUp={this.textinputKeyUp} />
                            <span className="input-group-addon txt-img icon"><i className="fas fa-search" onClick={() => this._loadData("Y")}></i></span>
                            <span className="input-group-addon txt-img icon"> <i className="fas fa-sync-alt" onClick={() => this._loadData("")}></i></span>
                        </div>
                        <BootstrapTable
                            data={this.state.rows}
                            options={{
                                onRowClick: this.onSelectRow,
                                noDataText: "ไม่พบข้อมูลที่ค้นหา",
                            }}
                            height="700"
                            condensed>
                            <TableHeaderColumn columnClassName="columnAll? columnID" dataAlign="center" width="20" dataField="any" dataFormat={indexN} ></TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll?" className="columnNumber" width="50" dataField='warehouse' isKey > รหัสคลัง </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll?" className="columnNumber" width="80" dataField='whname'  > ชื่อคลัง </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll?" className="columnNumber" width="80" dataField='location' > รหัสที่เก็บ </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll?" className="columnNumber" width="120" dataField='locname'  > ชื่อที่เก็บ </TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                    <i id="load"></i>
                </div>
                <Snackbar place="br"
                    color={this.state.color}
                    icon={this.state.icon}
                    autoClose={this.state.autoClose}
                    message={this.state.messagealert}
                    open={this.state.opensnackbar}
                    closeNotification={() => { this.setState({ opensnackbar: false }) }}
                    close />
            </div>
        );
    }
}